import type { AdminActivityQuery, AdminReportQuery, AdminReviewsQuery } from "@takt/api-client"

type ActivityCategory = NonNullable<AdminActivityQuery["category"]>
type ReviewVisibility = NonNullable<AdminReviewsQuery["visibility"]>
type ReportRange = NonNullable<AdminReportQuery["range"]>
export type ActivitySearch = { category?: ActivityCategory; companyId?: number; scope?: "24h" | "7d" | "30d" | "all" }
export type ReviewsSearch = {
    q?: string
    companyId?: number
    rating?: number
    visibility?: ReviewVisibility
    reviewId?: number
}
export type ReportsSearch = { range?: ReportRange }
type ActivityScope = NonNullable<ActivitySearch["scope"]>

const positiveInteger = (value: unknown) => {
    const parsed = Number(value)
    return Number.isSafeInteger(parsed) && parsed > 0 ? parsed : undefined
}

export function validateActivitySearch(search: Record<string, unknown>): ActivitySearch {
    const categories = new Set<ActivityCategory>(["company", "appointment", "employee", "moderation"])
    const scopes = new Set<ActivityScope>(["24h", "7d", "30d", "all"])
    const category =
        typeof search.category === "string" && categories.has(search.category as ActivityCategory)
            ? (search.category as ActivityCategory)
            : undefined
    const scopeValue = search.scope as ActivityScope
    const scope = typeof search.scope === "string" && scopes.has(scopeValue) ? scopeValue : undefined
    const companyId = positiveInteger(search.companyId)
    return {
        ...(category ? { category } : {}),
        ...(companyId ? { companyId } : {}),
        ...(scope && scope !== "30d" ? { scope } : {}),
    }
}

export function validateReviewsSearch(search: Record<string, unknown>): ReviewsSearch {
    const q = typeof search.q === "string" && search.q.trim() ? search.q.trim() : undefined
    const companyId = positiveInteger(search.companyId)
    const rating = positiveInteger(search.rating)
    const visibility = search.visibility === "visible" || search.visibility === "hidden" ? search.visibility : undefined
    const reviewId = positiveInteger(search.reviewId)
    return {
        ...(q ? { q } : {}),
        ...(companyId ? { companyId } : {}),
        ...(rating && rating <= 5 ? { rating } : {}),
        ...(visibility ? { visibility } : {}),
        ...(reviewId ? { reviewId } : {}),
    }
}

export function validateReportsSearch(search: Record<string, unknown>): ReportsSearch {
    return search.range === "7d" || search.range === "90d" ? { range: search.range } : {}
}
